import { Link } from 'react-router-dom';
import { brandInfo } from '@/mocks/data';

export default function BrandStory() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 bg-background-100 rounded-2xl p-8 md:p-12">
          <div className="lg:w-1/2">
            <div className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              关于我们
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              {brandInfo.name}
            </h2>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              {brandInfo.description}
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              {brandInfo.mission}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/about"
                className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
          <div className="lg:w-1/2 w-full">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 h-40 md:h-56 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20ripe%20juicy%20peaches%20hanging%20on%20tree%20branch%20with%20sunlight%20filtering%20through%20leaves%2C%20warm%20golden%20light%2C%20shallow%20depth%20of%20field%2C%20lush%20green%20foliage%20background%2C%20organic%20farm%20photography&width=600&height=480&seq=brand-orchard-1&orientation=landscape"
                  alt="水蜜桃果园"
                  title="水蜜桃视频品牌故事 - 果园实拍"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 h-40 md:h-56 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20video%20filming%20setup%20in%20a%20peach%20orchard%2C%20camera%20on%20tripod%20capturing%20peach%20trees%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%20content%20creation%2C%20warm%20natural%20atmosphere&width=600&height=480&seq=brand-filming-1&orientation=landscape"
                  alt="视频拍摄现场"
                  title="水蜜桃视频品牌故事 - 拍摄现场"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}